/** Helpers de combo grupo/empresa — testáveis sem HTTP real. */

export function cnpjDaEmpresaCombo(empresa) {
  return String(empresa?.id ?? "").replace(/\D/g, "");
}

export function parseItensCombo(response) {
  const combosFormat = (response?.detalhes?.itensCombo || [])
    .filter((item) => item)
    .map((item) => {
      const split = item.split("/|/");
      return { id: split[0], detalhes: split[1] };
    });
  return combosFormat.filter(
    (combo, index, self) =>
      index === self.findIndex((t) => t.detalhes === combo.detalhes)
  );
}

export async function carregarComboItens(codCombo, buscarComboPorCodigo) {
  const response = await buscarComboPorCodigo(codCombo);
  return parseItensCombo(response);
}

/**
 * Localiza grupo e empresa pelo CNPJ (14 dígitos).
 * @param {string} cnpj
 * @param {Array<{ id: string, detalhes: string }>} grupos
 * @param {(grupo: { id: string }) => Promise<Array<{ id: string, detalhes: string }>>} listarEmpresasDoGrupo
 */
export async function resolverGrupoEmpresaPorCnpj(cnpj, grupos, listarEmpresasDoGrupo) {
  const cnpjNorm = String(cnpj ?? "").replace(/\D/g, "");
  if (!/^\d{14}$/.test(cnpjNorm)) return null;

  for (const grupo of grupos) {
    const empresas = await listarEmpresasDoGrupo(grupo);
    const match = empresas.find((e) => cnpjDaEmpresaCombo(e) === cnpjNorm);
    if (match) {
      return { grupo, empresas, empresa: match };
    }
  }
  return null;
}

/**
 * Resolve grupo + empresa a partir do CNPJ numa única chamada (combo
 * GRUPO_EMPRESA_POR_CNPJ_<cnpj>, JOIN direto no backend) — usado no modo
 * "Adicionar período", onde grupo/empresa só servem de exibição (o CNPJ já
 * vem fixo da linha selecionada). Substitui resolverGrupoEmpresaPorCnpj
 * (que varre grupo por grupo) para não fazer uma requisição por grupo
 * económico cadastrado até achar o CNPJ certo.
 */
export async function resolverGrupoEmpresaPorCnpjDireto(cnpj, buscarComboPorCodigo) {
  const cnpjNorm = String(cnpj ?? "").replace(/\D/g, "");
  if (!/^\d{14}$/.test(cnpjNorm)) return null;

  const response = await buscarComboPorCodigo(`GRUPO_EMPRESA_POR_CNPJ_${cnpjNorm}`);
  const item = (response?.detalhes?.itensCombo || []).find(Boolean);
  if (!item) return null;

  const [idGrupo, nomeGrupo, cnpjEmpresa] = item.split("/|/");
  if (!idGrupo || cnpjDaEmpresaCombo({ id: cnpjEmpresa }) !== cnpjNorm) return null;

  const grupo = { id: idGrupo, detalhes: nomeGrupo };
  const empresa = { id: cnpjEmpresa, detalhes: cnpjEmpresa };
  return { grupo, empresas: [empresa], empresa };
}
